
   
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider as StoreProvider } from 'react-redux';
import store from './redux/store';
import { initializeApp, getApp } from 'firebase/app';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// Use local emulator config in development, otherwise fetch from hosting
const initFirebase = async () => {
    if (process.env.NODE_ENV === 'development') {
        // Local development with Firebase Emulators
        const firebaseConfig = {
            apiKey: 'fake-api-key',
            authDomain: 'localhost',
            projectId: 'fni-blueprint-dev',
        };
        initializeApp(firebaseConfig);

        const functions = getFunctions(getApp());
        const auth = getAuth(getApp());
        connectFunctionsEmulator(functions, 'localhost', 5001);
        connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    } else {
        // Production: fetch config from Firebase Hosting
        const response = await fetch('/__/firebase/init.json');
        initializeApp(await response.json());
    }

    ReactDOM.render(
        <React.Fragment>
            <StoreProvider store={store}>
                    <App />
            </StoreProvider>
        </React.Fragment>,
        document.getElementById('root'),
    );
};

initFirebase();
